import { FC, memo } from "react"

const PlusCircle: FC = () => {
    return (
        <>
            <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.83325 7.99992C1.83325 4.31802 4.81802 1.33325 8.49992 1.33325C12.1818 1.33325 15.1666 4.31802 15.1666 7.99992C15.1666 11.6818 12.1818 14.6666 8.49992 14.6666C4.81802 14.6666 1.83325 11.6818 1.83325 7.99992ZM8.49992 2.54537C5.48745 2.54537 3.04537 4.98745 3.04537 7.99992C3.04537 11.0124 5.48745 13.4545 8.49992 13.4545C11.5124 13.4545 13.9545 11.0124 13.9545 7.99992C13.9545 4.98745 11.5124 2.54537 8.49992 2.54537ZM8.49992 4.96962C8.83464 4.96962 9.10598 5.24096 9.10598 5.57568V7.39386H10.9242C11.2589 7.39386 11.5302 7.6652 11.5302 7.99992C11.5302 8.33464 11.2589 8.60598 10.9242 8.60598H9.10598V10.4242C9.10598 10.7589 8.83464 11.0302 8.49992 11.0302C8.1652 11.0302 7.89386 10.7589 7.89386 10.4242V8.60598H6.07568C5.74096 8.60598 5.46962 8.33464 5.46962 7.99992C5.46962 7.6652 5.74096 7.39386 6.07568 7.39386H7.89386V5.57568C7.89386 5.24096 8.1652 4.96962 8.49992 4.96962Z"
                    fill="black"
                />
            </svg>
        </>
    )
}

export default memo(PlusCircle)